import { useAtom } from "jotai";
import React, { useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { alertModal } from "../../AtomStore/store";
import FootpringSvg from "../../assets/left-nico.png";
import Constants from "../../constants";

const FootPrintModal = () => {
  const removeHtmlTags = (message) => {
    if (typeof message === "string") {
      const regex = /(<([^>]+)>)/gi;
      message = message.replace(regex, "");
      return message;
    }
    return message;
  };

  const [modal, setModal] = useAtom(alertModal);
  const closeModal = () => {
    setModal({ state: false });
  };

  // useEffect(() => {
  //   if (modal.state) {
  //     const timer = setTimeout(() => {
  //       setModal({ state: false });
  //     }, 5000);
  //     return () => clearTimeout(timer);
  //   }
  // });

  if (modal.state) {
    const { isConfirm = false, onOkPressed, onCancelPressed, message } = modal;
    return Constants.env.web === "yes" ? (
      <div>
        <Modal isOpen={typeof modal.message === "string"} toggle={closeModal}>
          <ModalHeader>Parent Connect Says....</ModalHeader>
          <ModalBody>{removeHtmlTags(message)}</ModalBody>
          <ModalFooter>
            {
              <Button
                className="bg-header text-white hover:bg-header hover:border-header"
                onClick={() => {
                  if (onOkPressed) {
                    onOkPressed();
                  }
                  closeModal();
                }}
              >
                Ok
              </Button>
            }
            {isConfirm === true && (
              <Button
                className="bg-header text-white"
                onClick={() => {
                  if (onCancelPressed) {
                    onCancelPressed();
                  }
                  closeModal();
                }}
              >
                Cancel
              </Button>
            )}
          </ModalFooter>
        </Modal>
      </div>
    ) : (
      <div className="fixed inset-0 flex items-end justify-center z-50 [@media(min-width:768px)]:ml-20">
        <div class="relative w-100 transform overflow-hidden rounded-3xl bg-white text-left shadow-xl translate-y-0 transition-transform duration-1000 ease-out  sm:my-8 sm:w-full sm:max-w-lg border-2 mx-2 mb-2 [@media(min-width:640px)]:absolute">
          <div class="bg-white px-4 pb-4 pt-4 sm:p-6 sm:pb-4">
            <div class="sm:flex sm:items-start [@media(min-width:640px)]:block">
              <div class="mx-auto animate-ping md:hidden flex h-20 w-20 flex-shrink-0 items-center justify-center rounded-full bg-header bg-opacity-20 sm:mx-0 sm:h-15 sm:w-15"></div>
              <div class="absolute inset-8.5 md:static md:inset-0 mx-auto flex h-15 w-15 flex-shrink-0 items-center justify-center rounded-full bg-header bg-opacity-70 sm:mx-0 sm:h-10 sm:w-10">
                {/* <svg class="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
              </svg> */}
                <img src={FootpringSvg} alt="Footprints" />
              </div>

              <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                <h3
                  class="text-base font-semibold leading-6 text-gray-900"
                  id="modal-title"
                >
                  Parent Connect
                </h3>
                <div class="mt-2">
                  <p class="text-sm text-gray-500">{removeHtmlTags(message)}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="bg-white px-4 py-3 flex flex-row-reverse [@media(min-width:640px)]:justify-center  sm:px-6">
            <button
              type="button"
              class="inline-flex w-full justify-center rounded-md bg-annual px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-annual ml-3 md:ml-0 sm:w-auto [@media(min-width:640px)]:w-[36%]"
              onClick={() => {
                if (onOkPressed) {
                  onOkPressed();
                }
                closeModal();
              }}
            >
              OK
            </button>

            {isConfirm === true && (
              <button
                type="button"
                class=" inline-flex w-full justify-center rounded-md bg-red-500 px-3 py-2 text-sm font-semibold text-white shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto [@media(min-width:640px)]:w-[36%]"
                onClick={() => {
                  if (onCancelPressed) {
                    onCancelPressed();
                  }
                  closeModal();
                }}
              >
                Cancel
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
};

export default FootPrintModal;
